const TAG_MODAL = 'TAG_MODAL';
const TICKET_TYPE_MODAL = 'TICKET_TYPE_MODAL';

export const ticketMgmtModalTypes = {
    TAG_MODAL,
    TICKET_TYPE_MODAL
};
